export const prepareFigureElements = (htmlValue: Document) => {
  const figureElements = htmlValue.querySelectorAll('figure')

  // Remove the figure wrapper if it was applied to the table
  figureElements.forEach((figureElement) => {
    if (figureElement.getAttribute('class') === 'table') {
      const fragment = document.createDocumentFragment()
      while (figureElement.firstChild) {
        fragment.appendChild(figureElement.firstChild)
      }
      figureElement.replaceWith(fragment)
    }

    // Remove the figure wrapper if it was applied to the image
    const imgElement = figureElement.querySelector('img')
    if (imgElement) {
      const fragment = document.createDocumentFragment()

      const figcaptionElement = figureElement.querySelector('figcaption')
      if (figcaptionElement) {
        const dataCaption = figcaptionElement.textContent?.trim()
        if (dataCaption) {
          imgElement.setAttribute('data-caption', dataCaption)
        }
      }

      fragment.appendChild(imgElement.cloneNode(true))

      figureElement.replaceWith(fragment)
    }
  })
}
